import { Injectable } from '@angular/core';
import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { BaseDAO } from './baseDAO';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { Charter } from 'anchor-shared/lib/model/entity/charter';
import { Payment } from 'anchor-shared/lib/model/entity/payment';
import { TransactionData } from '../../../app/portal/charters/manage-charter/manage-charter.component';

@Injectable()
export class PaymentDAO extends BaseDAO<Payment> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.PAYMENT);
  }

  public getCharterDetails(paymentId: number): Observable<any> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/' +
      paymentId +
      '/charter-details';
    let method = 'GET';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    let httpRequest: Observable<any> = this.apiHelper.apiCall<any>(
      url,
      method,
      null,
      null,
      headers,
      null,
    );

    return Observable.create((observer) => {
      httpRequest.subscribe(
        (res: any) => {
          observer.next(res);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        },
      );
    });
  }

  public getPublicCharterDetails(paymentId: number): Observable<any> {
    let url: string = `${this.apiHelper.getServiceName()}${this.getResource()}/${paymentId}/charter-details/public`;
    let method = 'GET';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(url, method, null, null, headers, null);
  }

  public updateFromPartial(
    id: number,
    payment: Partial<Payment>,
  ): Observable<Charter> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/' + id;
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(url, method, null, payment, headers);
  }

  public updateAdjustmentPayment(
    id: number,
    payment: Partial<Payment>,
  ): Observable<Charter> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/adjustment/' +
      id;
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(url, method, null, payment, headers);
  }

  public removePaymentIntent(charterId: number | string): Observable<any> {
    const url: string = `${this.apiHelper.getServiceName()}${this.getResource()}/remove-payment-intent/${charterId}`;
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(url, method, null, null, headers);
  }

  public getPaymentsByCharterId(charterId: number): Observable<Payment[]> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/charters/' +
      charterId;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {};
    return this.apiHelper.apiCall<any>(url, method, null, data, headers);
  }

  public getPaymentWithPayouts(paymentId: number): Observable<Payment> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/find-payments-with-payouts/' +
      paymentId;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<Payment>(url, method, null, null, headers);
  }

  public addManualStripeTransaction(
    transactionData: any,
    userEmail: string,
  ): Observable<any> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/manual-stripe-transaction';
    let method = 'POST';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      transactionData: transactionData,
      userEmail: userEmail,
    };
    return this.apiHelper.apiCall<any>(url, method, null, data, headers);
  }

  createManualPayment(manualTransactionData: TransactionData): Observable<any> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/create-manual-payment';
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(
      url,
      method,
      null,
      manualTransactionData,
      headers,
    );
  }

  createPayment(transactionData: any): Observable<any> {
    const url: string = this.apiHelper.getServiceName() + this.getResource();
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(
      url,
      method,
      null,
      transactionData,
      headers,
    );
  }

  createAdjustmentPayment(transactionData: any): Observable<any> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/adjustment';
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(
      url,
      method,
      null,
      transactionData,
      headers,
    );
  }

  deletePayment(paymentId: any): Observable<any> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      `/delete/${paymentId}`;
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(url, method, null, null, headers);
  }

  deleteAdjustmentPayment(paymentId: any): Observable<any> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      `/adjustment/${paymentId}`;
    const method = 'DELETE';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(url, method, null, null, headers);
  }
}
